export default __webpack_public_path__ + "static/media/ic-sort.95288216.svg";